var render = function render(){var _vm=this,_c=_vm._self._c;return _c('supplier-info',{attrs:{"distributor":_vm.distributor}})
}
var staticRenderFns = []

export { render, staticRenderFns }